import React from 'react';
import {connect} from "react-redux";

import {Card} from "@mui/material";
import CardContent from "@mui/joy/CardContent";
import Box from "@mui/material/Box";
import {useNavigate} from "react-router-dom";
import {useMediaQuery} from "react-responsive";
import ContextPicker from "../ContextPicker/ContextPicker";


const ContextSelectViewComponent = (props) => {
  const navigate = useNavigate();
  const isDesktop = useMediaQuery({ minWidth: 992 });

  const getPaddingLeft = () => {
    if (isDesktop) {
      if (props.leftNavigationOpen) {
        return 37;
      } else {
        return 10;
      }
    }
    return 1;
  };

  return (
    <Card sx={{
      height: '100vh',
      boxShadow: 'none',
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      overflowY: 'auto',
      borderRadius: 0,
      paddingLeft: getPaddingLeft(),
      backgroundColor: 'transparent'
    }}>
      <CardContent
        sx={{
          marginLeft: 2,
          marginRight: 2,

        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            marginTop: 5,
          }}
        >
        </Box>
        <ContextPicker onSelected={() => navigate('/freak')}/>
      </CardContent>
    </Card>
  )
};

const mapStateToProps = state => ({
  ...state,
  currentUser: state.common.currentUser,
  context: state.common.context,
  leftNavigationOpen: state.common.leftNavigationOpen,
});

export default connect(mapStateToProps)(ContextSelectViewComponent);
